import {
  BLUE,
  DARK,
  GRAY,
  GRAY_SECONDARY,
  ORANGE,
  ORANGE_SECONDARY,
  PRIMARY,
  SECONDARY,
  TEXT,
  YELLOW,
  WHITE,
  BLUE_DARK
} from 'constants/colors';

import { createTheme } from '@mui/material';

export const MuiTheme = createTheme({
  typography: {
    fontFamily: ['"signikaregular"', 'Arial', 'sans-serif'].join(', '),
    fontSize: 13,
    h1: {
      fontSize: '1.602em'
    },
    h2: {
      fontSize: '1.424em'
    },
    h3: {
      fontSize: '1.266em'
    },
    h4: {
      fontSize: '1.125em'
    }
  },
  palette: {
    primary: {
      main: PRIMARY,
      contrastText: WHITE
    },
    secondary: {
      main: SECONDARY,
      contrastText: WHITE
    },
    neutral: {
      main: GRAY_SECONDARY,
      contrastText: GRAY
    },
    lightGray: {
      main: '#F7F7F7',
      contrastText: DARK,
      light: '#F7F7F7',
      dark: '#EFEFEF'
    },
    blue: {
      main: BLUE,
      contrastText: WHITE,
      dark: BLUE_DARK
    },
    orange: {
      main: ORANGE,
      contrastText: WHITE
    },
    yellow: {
      main: YELLOW,
      contrastText: WHITE
    },
    dark: {
      main: DARK,
      contrastText: WHITE
    },
    text: {
      primary: TEXT
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 2,
          fontFamily: ['"signikasemibold"', 'Arial', 'sans-serif'].join(', ')
        },
        contained: {
          border: '1px solid transparent'
        },
        text: {
          border: '1px solid transparent'
        },
        containedPrimary: {
          backgroundColor: ORANGE,
          color: WHITE,
          '&:hover': {
            backgroundColor: ORANGE_SECONDARY
          }
        },
        containedSecondary: {
          backgroundColor: GRAY,
          color: WHITE,
          '&:hover': {
            backgroundColor: GRAY_SECONDARY
          }
        },
        outlinedSecondary: {
          borderColor: GRAY,
          color: GRAY
        },
        sizeMedium: {
          padding: '6px 16px'
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          border: '1px solid transparent'
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 13,
          backgroundColor: WHITE,
          color: TEXT,
          boxShadow: `0px 0px 2px 1px ${GRAY_SECONDARY}`,
          zIndex: 1
        },
        arrow: {
          color: WHITE
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: 0
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          variant: 'standard',
          color: TEXT,
          '&.read_mode': {
            color: TEXT,
            textFillColor: TEXT,
            '*': {
              color: TEXT,
              textFillColor: TEXT
            },
            '.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled': {
              color: TEXT,
              textFillColor: TEXT
            },
            '.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
              {
                borderColor: 'transparent'
              },
            '&.Mui-disabled, .Mui-disabled, .Mui-disabled:before': {
              background: 'none',
              border: 0,
              borderColor: 'transparent'
            },
            '.MuiInput-input': {
              color: TEXT,
              textFillColor: TEXT
            }
          }
        }
      },
      defaultProps: {
        variant: 'standard'
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          variant: 'standard',
          color: TEXT
        }
      },
      defaultProps: {
        variant: 'standard'
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: TEXT
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          color: TEXT
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '6px 8px 6px 24px'
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          fontSize: 13,
          marginRight: 0
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          color: TEXT,
          fontSize: 15
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        standardInfo: {
          backgroundColor: WHITE,
          border: `2px solid ${PRIMARY}`,
          color: TEXT
        },
        standardSuccess: {
          backgroundColor: WHITE,
          border: `2px solid ${PRIMARY}`,
          color: TEXT
        }
      }
    }
  }
});
